module.exports = __webpack_public_path__ + "media/public/images/slider/banner_desktop-799cdec030bbd21be26ec5c28e9b4c94.png";